
import { defineComponent } from 'vue';
import AdListItem from './AdListItem.vue';

export default defineComponent({
  emits: ['selected', 'hover'],
  props: {
    data: Array,
    selected: Object,
    viewType: Object,
  },
  components: {
    AdListItem,
  },
  methods: {
    onSelected(item: any) {
      this.$emit('selected', item);
    },
    onHover(item: any) {
      this.$emit('hover', item);
    },
  },
});
